"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileOptionsPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const context_1 = require("@jsonjoy.com/ui/lib/4-card/Popup/context");
const BasicButton_1 = require("@jsonjoy.com/ui/lib/2-inline-block/BasicButton");
const BasicButtonDelete_1 = require("@jsonjoy.com/ui/lib/2-inline-block/BasicButton/BasicButtonDelete");
const BasicTooltip_1 = require("@jsonjoy.com/ui/lib/4-card/BasicTooltip");
const Iconista_1 = require("@jsonjoy.com/ui/lib/icons/Iconista");
const EditorContextPopup_1 = require("../../../chrome/EditorContextPopup");
const FileOptions_1 = require("./FileOptions");
const state_1 = require("./state");
const context_2 = require("./context");
const context_3 = require("../../../context");
const preventMouseDown = (event) => {
    event.preventDefault();
};
const stopBubble = (event) => {
    event.stopPropagation();
};
const FileOptionsPopup = ({ element }) => {
    const [t] = (0, use_t_1.useT)();
    const popup = (0, context_1.usePopup)();
    const mutxt = (0, context_3.useMuTxt)();
    const state = React.useMemo(() => new state_1.FileOptionsState(mutxt, element, popup?.close), [mutxt, element, popup]);
    const headerRight = (
    // biome-ignore lint/a11y/useKeyWithClickEvents: click handler only stops bubbling; keyboard interaction is on inner buttons
    React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: 6 }, onMouseDown: stopBubble, onClick: stopBubble },
        React.createElement(BasicTooltip_1.BasicTooltip, { nowrap: true, renderTooltip: () => t('Download') },
            React.createElement(BasicButton_1.BasicButton, { type: "button", width: 32, height: 32, rounder: true, onMouseDown: preventMouseDown, onClick: state.download },
                React.createElement(Iconista_1.Iconista, { set: 'lucide', icon: 'download', width: 16, height: 16 }))),
        React.createElement(BasicTooltip_1.BasicTooltip, { nowrap: true, renderTooltip: () => t('Remove file') },
            React.createElement(BasicButtonDelete_1.BasicButtonDelete, { type: "button", width: 32, height: 32, rounder: true, onMouseDown: preventMouseDown, onConfirm: state.remove }))));
    return (React.createElement(context_2.ctx.Provider, { value: state },
        React.createElement(EditorContextPopup_1.EditorContextPopup, { title: t('File details'), subtitle: t('Rename, caption, or download the file.'), headerRight: headerRight, minWidth: 360, onCancel: state.cancel, onApply: state.apply },
            React.createElement(FileOptions_1.FileOptions, null))));
};
exports.FileOptionsPopup = FileOptionsPopup;
